import React, { useLayoutEffect } from 'react'
import { callNativeByParams, userBridge, getUA } from '@penguin/utils'
import qs from 'query-string'

const MeiZhuang = () => {
  const ua = getUA()
  const query = qs.parse(location.search)
  useLayoutEffect(() => {
    if (ua === 'app') {
      if (query.appOpenUrl) {
        callNativeByParams('jumpNativePage', {
          url: decodeURIComponent(query.appOpenUrl as string),
        })
        userBridge('popWindow')
      }
    }
  }, [])
  return (
    <div>
      <img
        className='h-auto w-100'
        src='//static.qiekj.com/static/web/image/meizhuang_land_1727595910605.png'
        alt=''
      />
    </div>
  )
}

export default MeiZhuang
